import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _class, _descriptor, _descriptor2;
/* import __COLOCATED_TEMPLATE__ from './assistant-item.hbs'; */
import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { focusSearchInput } from "discourse/components/search-menu";
import getURL from "discourse-common/lib/get-url";
import { debounce } from "discourse-common/utils/decorators";
import TEMPLATE from "./assistant-item.hbs";
import { setComponentTemplate } from "@ember/component";
const _itemSelectCallbacks = [];
export function addItemSelectCallback(fn) {
  _itemSelectCallbacks.push(fn);
}
export function resetItemSelectCallbacks() {
  _itemSelectCallbacks.length = 0;
}
let AssistantItem = (_dec = debounce(100), (_class = class AssistantItem extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "search", _descriptor, this);
    _initializerDefineProperty(this, "appEvents", _descriptor2, this);
    _defineProperty(this, "icon", this.args.icon || "search");
  }
  get href() {
    let href = "#";
    if (this.args.category) {
      href = this.args.category.url;
      if (this.args.tags && this.args.isIntersection) {
        href = getURL(`/tag/${this.args.tag}`);
      }
    } else if (this.args.tags && this.args.isIntersection && this.args.additionalTags?.length) {
      href = getURL(`/tag/${this.args.tag}`);
    }
    return href;
  }
  get prefix() {
    let prefix = "";
    if (this.args.suggestionKeyword !== "+") {
      prefix = this.search.activeGlobalSearchTerm?.split(this.args.suggestionKeyword)[0].trim() || "";
      if (prefix.length) {
        prefix = `${prefix} `;
      }
    } else {
      prefix = this.search.activeGlobalSearchTerm;
    }
    return prefix;
  }
  get tagsSlug() {
    if (!this.args.tag || !this.args.additionalTags) {
      return;
    }
    return `tags:${[this.args.tag, ...this.args.additionalTags].join("+")}`;
  }
  onKeydown(e) {
    // don't capture tab key
    if (e.key === "Tab") {
      return;
    }
    if (e.key === "Escape") {
      this.args.closeSearchMenu();
      e.preventDefault();
      return false;
    }
    if (e.key === "Enter") {
      this.itemSelected();
    }
    this.search.handleArrowUpOrDown(e);
    e.stopPropagation();
    e.preventDefault();
  }
  onClick(e) {
    this.itemSelected();
    e.preventDefault();
    return false;
  }
  itemSelected() {
    let updatedTerm = "";
    if (this.args.slug && (this.args.suggestionKeyword || this.args.concatSlug)) {
      updatedTerm = this.prefix.concat(this.args.slug);
    } else {
      updatedTerm = this.prefix.trim();
    }
    const inTopicContext = this.search.searchContext?.type === "topic";
    const searchTopics = !inTopicContext || this.search.activeGlobalSearchTerm;
    if (_itemSelectCallbacks.length && !_itemSelectCallbacks.some(fn => fn({
      updatedTerm,
      searchTermChanged: this.args.searchTermChanged,
      usage: this.args.usage
    }))) {
      // Return early if any callbacks return false
      return;
    }
    this.args.searchTermChanged(updatedTerm, {
      searchTopics,
      ...(inTopicContext && !this.args.searchAllTopics && {
        setTopicContext: true
      })
    });
    focusSearchInput();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "search", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemSelected", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "itemSelected"), _class.prototype)), _class));
export { AssistantItem as default };
setComponentTemplate(TEMPLATE, AssistantItem);